<script setup>
import {
  useFloating,
  offset,
  shift,
  autoUpdate,
  flip,
  // limitShift,
} from '@floating-ui/vue';

const props = defineProps({
  referenceRef: {
    type: [Object, null],
    required: true,
  },
  position: {
    type: String,
    default: 'bottom-start',
  },
  autoFlip: {
    type: Boolean,
    default: true,
  },
  gap: {
    type: Number,
    default: 0,
  },
});

const referenceElement = computed(() => props.referenceRef);
const rootRef = ref(null);

// init floating plugin
const { floatingStyles, placement } = useFloating(referenceElement, rootRef, {
  placement: props.position,
  middleware: [
    offset(() => props.gap),
    shift({
      // TODO: not working in @floating-ui/vue
      // limiter: limitShift({ offset: () => props.gap }),
    }),
    ...(props.autoFlip ? [flip()] : []),
  ],
  whileElementsMounted: autoUpdate,
});

// placement
const placementDirections = ['top', 'left', 'right', 'bottom'];

const placementDirection = computed(() =>
  placementDirections.find((direction) =>
    placement.value.startsWith(direction),
  ),
);
</script>

<template>
  <div ref="rootRef" :style="floatingStyles">
    <slot :placement="placementDirection" />
  </div>
</template>
